// Mapping of ISO currency codes to display symbols used across the dashboard.
// Extend this object as new currencies are onboarded (Phase 2 will read the
// active code from the seller payload via SellerContext).
export const CURRENCY_SYMBOLS = {
  USD: "$",
  GTQ: "Q",
  Q: "Q",
  QTZ: "Q",
  COP: "$",
  PEN: "S/",
  NIO: "C$",
  "C$": "C$",
  CRC: "₡",
  SRD: "SRD",
};

export const DEFAULT_CURRENCY_CODE = "USD";
export const DEFAULT_CURRENCY_SYMBOL = CURRENCY_SYMBOLS[DEFAULT_CURRENCY_CODE];

export const getSymbolForCode = (code) =>
  CURRENCY_SYMBOLS[code] || DEFAULT_CURRENCY_SYMBOL;
